/*
 * Headerbidding Integration For A9 Prebid
 * More info at: https://confluence.webmd.net/display/CPM/Third+Party+Service+Integration
 * @requires jQuery
 */

import { ua } from 'webmd-useragent';
import debug from 'webmd-debug';
import cookie from 'webmd-cookie';
require("webmd-ad-kibana");
require("webmd-tug-eval-promise");

if ( typeof window !== 'undefined' ) {
  window.googletag = window.googletag || {};
  googletag.cmd = googletag.cmd || [];

  window.requestedSlots = [];

  let amznA9 = {

    // array of promises for tracking application state.
    promises: [],

    // returns an array of pos's for slots we want Amazon to bid on
    getBidsPos: function(){
      if (ua.type === 'mobile') {
        return ["2025", "2026", "1923"];
      } else {
        return ["101", "113", "121", "137", "147", "141"];
      }
    },

    // load a script tag
    loadScript : function(tagSrc) {
      let scriptTag = document.createElement('script');
      let placeTag = document.getElementsByTagName("script")[0];

      if (tagSrc.substr(0, 4) !== 'http') {
        let isSSL = true;
        tagSrc = (isSSL ? 'https:' : 'http:') + tagSrc;
      }

      scriptTag.type = 'text/javascript';
      scriptTag.src = tagSrc;
      scriptTag.async = true;

      // placing the apstag bootstrap
      var pStyle = window.document.createElement("link");
      pStyle.rel = "dns-prefetch";
      pStyle.href = "https://c.amazon-adsystem.com";
      window.parent.document.head.appendChild(pStyle);
      pStyle.rel = "preconnect";
      pStyle.setAttribute("crossorigin",'');
      window.parent.document.head.appendChild(pStyle);

      placeTag.parentNode.insertBefore(scriptTag, placeTag);
      /**
       * performance mark to spot when amazon library has started loading
       */
      try {
        window.performance.mark("amazon-load-start");
        window.performance.measure('measure-amazon-load-start', 'ads-code-load', 'amazon-load-start');
        debug('(Perf-Mark) Amazon load started -> ' + window.performance.getEntriesByName('measure-amazon-load-start', 'measure')[0].duration);
      } catch (e) {
        debug(e)
      }
      
      window.__loada9Promise = new Promise(function(resolve, reject) {
        scriptTag.onload = function () {
          /**
           * performance mark to spot when amazon library has loaded
          */
         try {
          window.performance.mark('amazon-loaded');
          window.performance.measure('measure-amazon-loaded', 'ads-code-load', 'amazon-loaded');
          debug('(Perf Mark) Amazon loaded -> ' + window.performance.getEntriesByName('measure-amazon-loaded', 'measure')[0].duration);

         } catch (e) {
          debug(e)
         }
          debug('apstag loaded successfully');
          resolve();
        };
        scriptTag.onerror = function() {
          window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-amazon", "webmd-apstag-load-failed");
          debug('apstag not loaded on error');
          reject();
        } 
      });      
    },

    // Load and initialize the apstag headbidding Javascript Library and bootstrap the API methods
    loadA9 : function() {
      let self = this;
      var host = window && window.location.host;

      (function(a9,a,p,s,t,A,g){
        if (a[a9]) {
          return;
        }
        function q(c,r){
          a[a9]._Q.push([c,r]);
        }

        if(host.indexOf('webmd.com') > -1) {
          a[a9] = {
            init:function(){q("i",arguments);},
            fetchBids:function(){q("f",arguments);},
            setDisplayBids:function(){},
            targetingKeys:function(){return [];},
            dpa:function(){q("di",arguments)},
            rpa:function(){q("ri",arguments)},
            upa:function(){q("ui",arguments)},
            _Q:[]
          };
        } else {
          a[a9] = {
            init:function(){q("i",arguments);},
            fetchBids:function(){q("f",arguments);},
            setDisplayBids:function(){},
            targetingKeys:function(){return [];},
            _Q:[]
          };
        }

        self.loadScript(t);
      })("apstag",window,document,"script","//c.amazon-adsystem.com/aax2/apstag.js");

      // initialize the library
      window.apstag.init({
        pubID: '3100',
        adServer: 'googletag',
        videoAdServer: 'googletag',
        deals: true,
      });

      // Calling the rpa method for Amazon publisher services (Audience management) - If hash key available
      if (cookie.get('REG_UUID') != '' && host.indexOf('webmd.com') > -1) {
        window.tokenConfig = { 'optOut': false,'hashedRecords': [] };
        if (window.OptanonActiveGroups && window.OptanonActiveGroups.indexOf('C0004') === -1) { 
          window.tokenConfig.optOut = true;
        }
        window.tokenConfig.hashedRecords = [{ 'type': "email",'record': cookie.get('REG_UUID') }]
        window.apstag.rpa(
          window.tokenConfig
          ,function () {
          debug("Amazon token is stored");
        })
      }
    },
    // get the A9 bids
    getA9Bids : function() {
      let mappings = this.getBidsPos();
      let slots = [];
      let a9TimeoutRequestAds;
      let a9Timeout = 800; // A9 timeout
      let gptSlots = googletag.pubads().getSlots();

      if (typeof window.apstag === 'undefined') {
        debug('===== APSTAG is undefined =====');
        return;
      }

      if (gptSlots.length < 1) {
        return; // no ad slots on this page
      }

      this.promises.push(new Promise( (resolve) => {
        // if A9 request does not return in time, resolve the promise.
        a9TimeoutRequestAds = setTimeout(function(){
          resolve("A9 bid request failed to complete in time");
          window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-amazon", "webmd-apstag-bid-request-timeout");
        }, a9Timeout);
      }));

      /*
       * create the bid requests based on slots we want Amazon to bid on
       * A9 developer reference: https://ams.amazon.com/webpublisher/uam/docs/web-integration-documentation/integration-guide/javascript-guide/display.html
       */
      for (let i = 0; i < gptSlots.length; i++) {
        if (mappings.indexOf(gptSlots[i].getTargeting('pos')[0]) > -1 && window.requestedSlots.indexOf(gptSlots[i].getSlotElementId()) < 0) {
          let ad = gptSlots[i];
          let slot = {};
          slot.slotID = ad.getSlotElementId();

          slot.sizes = ad.getSizes().map(function(size){
            return Object.values(size);
          });

          slot.slotName = ad.getAdUnitPath() + '/' + ad.getSlotElementId();
          slots.push(slot);
          window.requestedSlots.push(ad.getSlotElementId());
        }
      }

      this.promises.push(new Promise( (resolve, reject) => {
        if (slots.length > 0) {
          try {
            window.apstag.fetchBids({
              slots: slots,
              timeout: a9Timeout
            }, function(bids) {
              googletag.cmd.push(function(){

                // set the apstag targeting on googletag
                window.apstag.setDisplayBids();

                // clear the bid request timeout
                clearTimeout(a9TimeoutRequestAds);

                // resolve the promise
                resolve(bids);
              });
            });
          } catch(e){
            debug(e);
            reject('An exception occured while fetching A9 bids');
            window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-amazon", "webmd-apstag-bidrequest-failed");
          }
        } else { // if there aren't any slots to bid on
          resolve('no slot to bid on');
          window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-amazon", "webmd-apstag-no-slots-to-bid");
        }
      }));

      window.tpsvc.promises.push(Promise.race(this.promises));
      this.promises = [];
    },
    shouldRemoveAds: function() {
            // Check if window.location and window.location.search are defined
            if (typeof window !== 'undefined' && window.location) {
                return window.location.href.indexOf('conmktvid') > -1;
            }
            return false; // Return false if the checks fail
        }
  };

  // initialize the third party service namepace, command queue and promises queue
  window.tpsvc = window.tpsvc || {};

  // The ads code will execute every command inside this queue before an ad request is made
  window.tpsvc.cmds = window.tpsvc.cmds || [];

  // The ads code will wait for every promise in this queue to resolve before an ad request is made
  window.tpsvc.promises = window.tpsvc.promises || [];

  (function() {
    //PPE-324582 : Disable Vendor
  	//Disable vendor if url containts vendor=0 or amazonheaderbidding=0
  	var url = (document.referrer) ? document.referrer : document.location.href;
    if (url && (url.indexOf('vendor=0') > -1 || url.indexOf('am=0') > -1)) {
      return false;
    }

    // Disable vendor for Care profile pages based on specialty
    // If a blocked specialty is found, the following code should not be executed
    if (window.location.href.includes('/doctor/')) {
      const blockSpecialtyIds = new Set(['29285', '29313', '29326', '29245', '29261']);
      let initialState = window.__INITIAL_STATE__;
      if ( initialState && initialState.profile && initialState.profile.specialites ) {
        let specialties = initialState.profile.specialites;
        const hasBlockedSpecialty = specialties.some(({ Id }) => blockSpecialtyIds.has(Id));
        if (hasBlockedSpecialty) return;
      }
    }

    // Disabling vendor for below topics and referrer should not be medscape.com - CONSMEDIA-20484
    // let topics = ['3564', '4270', '3642', '1828', '1836', '1830']; 
    if (typeof window.prebidExperiment !== 'undefined' && window.prebidExperiment && !window.document.referrer.includes('medscape.com') ) {
      return;
    }
		 
    // Disable vendor based on ads admin tool data
    if(window.globalConfig && window.globalConfig.ads) {

      let vendorConfig = window.globalConfig.ads.vendorConfig;
      let amazonConfig = vendorConfig.amazon ? vendorConfig.amazon : {};
      let location = cookie.getJson('gtinfo');
			
      /**
       *  Gtinfo cookie stores country code in lowercase while admin tool db stores in uppercase
       *  hence text transform is done.
       */
      let isLocationAdded = false;
      let countryCode = location.cntr ? location.cntr.toUpperCase() : '';
      let locationList = amazonConfig.location ? amazonConfig.location : [];
                                                                                                                                    
      /** 
       *  If the gtinfo is not available and only some of the locations are selelcted, 
       *  location based vendor suppression cannot be done properly. Hence, vendors can be loaded 
       *  as default behavior. 
       * 
       *  If location property is undefined or no countries are added in location array 
       *  or all the countries are selected, then it can be considered as 
       *  all the locations are selected and not required to check for gtinfo.
       *  Countries available in WebMD gtinfo file : 249
       */
      if ( !(countryCode == '' && locationList.length > 0 && locationList.length < 249) ) {
        if ( locationList.length == 0 || locationList.length == 249 || locationList.includes(countryCode) ) {
          isLocationAdded = true;
        }
        /**
         *  If disable is true and the location is included in the location array, 
         *  then vendor should not be loaded.   
         *  If disable is set to false and certain countries are added in location array, 
         *  then for the countries that are not added in the array can be considered 
         *  to have disable : true and vendor should not be loaded in this case. 
         */
        if (amazonConfig.disable && isLocationAdded) {
          return false;
        } else if ( !(amazonConfig.disable) && !isLocationAdded ) {
          return false;			
        }
      }
    }

    // if in iframe, exit immediately;
    if (window.top !== window.self) {
      return;
    }

    // if we are on sensitive topic pages
    if (window.s_sensitive && window.s_sensitive === "true") {
      return false;
    }

    // don't execute on member and fit pages
    // if we are on fit,member, labs or webmdrx page, return immediately
    if ( (/member.|fit.|labs.|webmdrx\./).test(location.host)) {
      return;
    }

    // allow other code to disable this beacon
    if ( window.location.href.indexOf('nobeacon') > -1) {
      debug('///// Amazon headerbidding not loaded due to beaconDisable /////');
      return false;
    }

    // do not run header bidding if it is a sponserd programme page
    if (window.s_sponsor_brand && window.s_sponsor_brand.length > 0) {
      return false;
    }

    if(window.s_sponsor_program && window.s_sponsor_program.length > 0){
      return false;
    }

    //do not run header bidding on video pages
    if(window.s_contains_video){
      return false;
    }
    /**
     * we need to load a9(apstag.js) once __tcfapiPromise is resolved,
     * the Promise is resolved once tcfapi.js is loaded onto the page
     * 
     * tcfapi.js is loaded only in EU locations and in other locations the Promise is
     * resolved immediately (handled in IAB stub code - webmd-ccm.js)
     * 
     * Ref: https://jira.internetbrands.com/browse/PPE-279145
     */
      function startA9 (){
        Promise.resolve(window.tugEvalPromise).then(function(sponsor){
          if(sponsor){
            return;
          }
          else if(amznA9.shouldRemoveAds()){
            return;
          }
          else{
            amznA9.loadA9();
            /*
            * queue the A9 bid request.
            * This will be executed in the future, just before the webmd ad request is made
            */
            window.tpsvc.cmds.push(amznA9.getA9Bids.bind(amznA9));
          }
        });
      }
      Promise.resolve(window.__tcfapiPromise).then(function () {
        if(window.globalConfig && window.globalConfig.ads) {
            let vendCon = window.globalConfig.ads.vendorConfig || {};
            let amzCon = vendCon.amazon ? vendCon.amazon : {};
            if(amzCon && amzCon.disable){
              return false
            }else{
              startA9();
            }
        }else{
          startA9();
        }
        
      });
  })();
}
